var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container-error"},[_c('div',{staticClass:"error-wrapper"},[_c('Exception',{attrs:{"tip-text":_vm.exceptionTipText,"placeholder-class-name":"system-error-img","show-retry-btn":_vm.showRetry,"show-back-btn":_vm.showBack},on:{"retry":_vm.reload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }